import { component as defineComponent } from 'flightjs';
import $ from 'jquery';

function ShowHideTestimonial() {
    this.postSubmitShowHideForm = function (e, data) {
        const self = this;
        $.ajax({
            url: data.url,
            data: data.formData,
            type: 'POST',
            success() {
                self.trigger(self.$node, 'dataShowHideFormSubmitSuccess', { response: data });
            },
            error() {
                self.trigger(self.$node, 'dataShowHideFormSubmitError');
            },
        });
    };

    this.after('initialize', function () {
        this.on(this.$node, 'uiNeedsShowHideFormSubmit', this.postSubmitShowHideForm);
    });
}

export default defineComponent(ShowHideTestimonial);



// WEBPACK FOOTER //
// ./src/js/component_data/testimonial.js